<template>
  <div class="login-page">
    <div class="login-backdrop"><div class="brand-mark">🌱</div><h1>星露谷 AI</h1><p>和你的伙伴一起，经营一个持续生长的世界。</p></div>
    <main class="login-panel">
      <div class="mobile-brand">🌱 星露谷 AI</div>
      <p class="eyebrow">管理平台</p>
      <h2>欢迎回来</h2>
      <p class="description">登录后查看游戏世界与服务运行状态。</p>
      <el-form class="login-form" @submit.prevent="submit">
        <label for="username">管理员账号</label>
        <el-input id="username" v-model.trim="username" autocomplete="username" size="large" placeholder="请输入管理员账号" clearable />
        <label for="password">登录密码</label>
        <el-input id="password" v-model="password" type="password" show-password autocomplete="current-password"
          size="large" placeholder="请输入登录密码" @keyup.enter="submit" />
        <p v-if="error" class="error" role="alert">{{ error }}</p>
        <el-button type="primary" native-type="submit" size="large" class="submit" :loading="loading" :disabled="!username || !password" @click="submit">登录管理平台</el-button>
      </el-form>
      <div class="player-entry">
        <strong>🌿 我是联机玩家</strong>
        <p>不需要管理账号。下载轻量启动器，自动准备 AI 伙伴 MOD，然后一键启动游戏。</p>
        <a class="launcher-download" href="/downloads/launcher/StardewAI-Launcher-v1.0.1.zip" download>下载 Windows AI 联机启动器 <span>v1.0.1</span></a>
      </div>
    </main>
  </div>
</template>
<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { login, authErrorMessage } from '../auth'
const router = useRouter()
const username = ref('Quella')
const password = ref('')
const loading = ref(false)
const error = ref('')
async function submit() {
  if (loading.value || !username.value || !password.value) return
  loading.value = true
  error.value = ''
  try {
    const user = await login(username.value, password.value)
    password.value = ''
    await router.replace(user.mustChangePassword ? '/account/password' : '/')
  } catch (e) {
    error.value = authErrorMessage(e, '登录失败，请检查网络后重试')
  } finally {
    loading.value = false
  }
}
</script>
<style scoped>
.login-page{min-height:100vh;display:flex;overflow:hidden;background:#fbfaf2}
.login-backdrop{width:52%;position:relative;overflow:hidden;padding:8%;display:flex;flex-direction:column;justify-content:center;background:radial-gradient(circle at 80% 16%,#fff9cf 0 12%,transparent 12.3%),linear-gradient(163deg,#d9eddc 0%,#b9daba 43%,#8fbd8e 100%);color:#365b45}
.login-backdrop:before{content:'';position:absolute;width:120%;height:230px;bottom:-70px;left:-12%;background:#77a878;border-radius:50% 60% 0 0;transform:rotate(-8deg);box-shadow:0 -28px 0 8px #95c397}
.login-backdrop:after{content:'';position:absolute;right:13%;bottom:85px;width:110px;height:105px;background:linear-gradient(to bottom,transparent 0 30%,#e7d0a5 31% 100%);clip-path:polygon(50% 0,100% 32%,93% 32%,93% 100%,10% 100%,10% 32%,0 32%);opacity:.8}
.brand-mark,.login-backdrop h1,.login-backdrop p{position:relative;z-index:2}
.brand-mark{font-size:61px;margin-bottom:8px}.login-backdrop h1{font-size:clamp(35px,4vw,52px);margin:7px 0 14px;letter-spacing:2px;font-weight:800;color:#31583d}
.login-backdrop p{line-height:2;font-size:16px;color:#597760;max-width:350px}
.login-panel{width:48%;display:flex;flex-direction:column;justify-content:center;max-width:540px;margin:auto;padding:64px}
.eyebrow{font-size:11px;font-weight:750;color:#6f9972;letter-spacing:3px}.login-panel h2{font-size:31px;margin:6px 0 8px;color:#2d4d39}
.description{font-size:14px;color:#7b8b7d;margin-bottom:30px;line-height:1.8}
.login-form{display:flex;flex-direction:column;gap:11px}.login-form label{font-size:13px;color:#415c49;font-weight:650;margin-top:10px}
.login-form :deep(.el-input__wrapper){min-height:48px;background:#fffefb!important}
.submit{margin-top:17px;width:100%;height:47px;font-size:14px}
.error{color:#ad4a43;font-size:13px;margin:0;line-height:1.6}
.mobile-brand{display:none}.player-entry{margin-top:19px;padding:16px 19px;background:#ecf5e9;border:1px solid #d5e5d0;border-radius:13px;color:#385b41}.player-entry strong{font-size:15px}.player-entry p{color:#647d68;font-size:12px;line-height:1.8;margin:7px 0 13px}.launcher-download{display:block;text-align:center;padding:11px;background:#527c55;color:#fff;border-radius:9px;font-weight:700;font-size:13px;text-decoration:none}.launcher-download span{opacity:.76;font-weight:400}
@media(max-width:850px){.login-backdrop{display:none}.login-page{align-items:center}.login-panel{width:100%;padding:26px;max-width:450px}.mobile-brand{display:block;font-size:20px;color:#547c54;font-weight:800;margin-bottom:45px}}
</style>